module.exports = __webpack_public_path__ + "img/christine-and-the-queen.761c8c27.jpg";